import commonApi from './CommonApi.js';

export default {
	create: async (viewModel) => {
		return await commonApi().post('/v1/admin/userDomains', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	delete: async (parameters) => {
		return await commonApi().delete('/v1/admin/userDomains', { params: parameters })
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	getByUserId: async (parameters) => {
		return await commonApi().get('/v1/admin/userDomains/getByUserId', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/admin/userDomains', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
}